// extracted by mini-css-extract-plugin
module.exports = {"addressSection":"addressSection__2WSQz","flatSection":"flatSection__3beKl addressSection__2WSQz","label":"label__AkIpC","title":"title__3NxZ5","archived":"archived__13K34"};